<div class="form-item" [ngClass]="'form-field-'+field.type">
  <div class="form-field-menu">
    <core-helpers-navigation-three-dots-menu
      [menu]="fieldMenu"
      (action)="onMenuClick($event)"
    ></core-helpers-navigation-three-dots-menu>
  </div>
  <div class="form-item-fields" [ngClass]="{'invalid-field': field.label == ''}">
    <input type="text" [ngModel]="field.label" [placeholder]="placeholder" (ngModelChange)="onFieldChange($event)">
    <div class="field-list">
    <ul *ngIf="field.values && field.values?.length > 0">
      <li *ngFor="let opt of field.values; index as i; trackBy: trackByFn">
        <input type="text" [ngModel]="opt" (ngModelChange)="onOptionChange($event, i)"  [placeholder]="optionsplaceholder"/>
        <span title="Remove" class="field-option field-option-remove" [hidden]="optIsReally(opt, i)" (click)="removeOption(opt, i)"> <em>Remove</em></span>
        <span title="Really?" class="field-option field-option-really" [hidden]="!optIsReally(opt, i)" (click)="reallyRemoveOption(opt, i)"> <em>Really?</em> </span>
      </li>
    </ul>
    </div>
  </div>
  

  <div class="field-mandatory">
    <core-helpers-forms-input-checkbox
      [label]="'Make field mandatory'"
      [form]="form"
      [defaultChecked]="field.mandatory"
      (checkedChange)="onMandatoryChange($event)"
    ></core-helpers-forms-input-checkbox>
  </div>
</div>